import PaginaFornecedor from '@/modules/pagina-fornecedor/PaginaFornecedor.vue';

export default [
  {
    path: 'pag/fornecedor/:id',
    name: 'main.pagina-fornecedor',
    components: {
      default: PaginaFornecedor,
    },
  },
];
